import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { AppService } from "@api";
import { RelacionPreguntaComponent } from "@contenido/AppContent/global/relacionpregunta/relacionPregunta.component";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum, DialogoEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { Pregunta } from "@modelo/proceso/Pregunta.model";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { PreparacionEvaluacion } from "@modelo/proceso/preparacionpuesto.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { DxDataGridComponent } from "devextreme-angular";


@Component({
    selector: 'preparacionpregunta_opcional',
    templateUrl: './preparacionevaluacionpregunta_opcional.component.html',
    styleUrls: ['../../preparacionevaluacion.component.scss']
})

export class PreparacionPreguntaOpcionalEvaluacionComponent implements AfterViewInit{
    consulta!: boolean;
    entidad: PeriodoEvaluacion;
    entidadpregunta: Pregunta
    @Input() id!: number;
    @Input() idpuesto!: number;
    @Input() iddepartamento!: number;
    @Input() entidadpuesto!: PreparacionEvaluacion;
    @Output() actualizar = new EventEmitter();

    DataPeriodoPorPlantilla: any[];
    selectedRows:any[];
    ListPreguntas: any[]
    listPreguntaReal: any[];

    @ViewChild('preguntaimportar') private relacionpregunta!: RelacionPreguntaComponent;

    @ViewChild(DxDataGridComponent, {static: false}) grid!: DxDataGridComponent;

    cambio!:boolean;

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
        this.entidad = new PeriodoEvaluacion();
        this.entidadpregunta = new Pregunta();

        this.DataPeriodoPorPlantilla = [];
        this.selectedRows = [];
        this.ListPreguntas = [];
        this.listPreguntaReal = [];

    }

    ngAfterViewInit(){
        this.setPreguntasPreparacion();


    }

    setPreguntasPreparacion(){
        this.appService.Post("planeacion/preparacionevaluacion/preparacion/puesto/pregunta/buscar",{"periodoevaluacionid":this.id, "puestoid":this.idpuesto, "tipoclaseid":1 ,"departamentoid":this.iddepartamento }).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.listPreguntaReal = res.data;
                this.ListPreguntas = this.listPreguntaReal.filter(x=> x.Seccionid != '1');
            }
        });
    }

    AgregarPregunta(){
        if(this.listPreguntaReal.length > 0){
            this.relacionpregunta.quitarrelacionados = true;
            for(let pregunta of this.listPreguntaReal){
                this.relacionpregunta.PreguntasYaSeleccionadas.push(pregunta.preguntaid);
            }
            this.relacionpregunta.Modal();
        }else{
            this.mensajeService.Alerta(AlertaEnum.Warning, "No tienes una plantilla asignada para este departamento.");
        }

    }

    PreguntasNuevas(e:any){
        let valor = new PreparacionEvaluacion(this.entidadpuesto);
        valor.fechaedicion = new Date();
        let año = valor.fechaedicion.getFullYear()
        let mes = valor.fechaedicion.getMonth() + 1
        let dia = valor.fechaedicion.getDate()
        let hora = valor.fechaedicion.getHours()
        let minuto = valor.fechaedicion.getMinutes()
        let fechafinal = año+"/"+mes+"/"+dia+" "+hora+":"+minuto
        valor.fechaedicion = fechafinal;
        valor.usuario = this.sistemaService.usuario.nombre;
        let periodopregunta = {"periodoevaluacionid": this.id, "puestoid": this.idpuesto, "preguntas": e, "periodoporpuesto":valor};
        this.appService.Post("planeacion/preparacionevaluacion/preparacion/puesto/pregunta",periodopregunta).then(res =>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.relacionpregunta.PreguntasYaSeleccionadas = [];
                this.relacionpregunta.CerrarModal()
                this.setPreguntasPreparacion();
                this.actualizar.next();

            }
        })
    }

    Guardar(e:any = 0): Promise<any>{
        return new Promise((resolve, reject) => {
            if(this.listPreguntaReal.length > 0){
                let valor = new PreparacionEvaluacion(this.entidadpuesto);
                valor.fechaedicion = new Date();
                let año = valor.fechaedicion.getFullYear()
                let mes = valor.fechaedicion.getMonth() + 1
                let dia = valor.fechaedicion.getDate()
                let hora = valor.fechaedicion.getHours()
                let minuto = valor.fechaedicion.getMinutes()
                let fechafinal = año+"/"+mes+"/"+dia+" "+hora+":"+minuto
                valor.fechaedicion = fechafinal;
                valor.usuario = this.sistemaService.usuario.nombre;
                let periodopregunta = {"periodoevaluacionid": this.id, "puestoid": this.idpuesto, "preguntas": this.ListPreguntas,"periodoporpuesto":valor}
                this.appService.Put("planeacion/preparacionevaluacion/preparacion/puesto/pregunta/guardar", periodopregunta).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success){
                        resolve({valor:true});
                    }
                })
            }else{
                this.mensajeService.Alerta(AlertaEnum.Warning, "No Cuenta con ninguna pregunta para asignar por favor verifique sus plantillas");
                resolve({valor:false});
            }

        })
    }

    onSelectionChanged(e: any) {
        this.grid.instance.cancelEditData();
        this.grid.instance.saveEditData();

        (e.currentDeselectedRowKeys as any[]).forEach(x => {
            x.Activo = false;
        });
    }

    Eliminar(id:number){
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("planeacion/preparacionevaluacion/eliminar/pregunta/" + id).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success){
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.setPreguntasPreparacion();
                    }
                })
            }
        })
    }

}
